import { useSelector } from "react-redux";
import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import type { AppCoreState } from "../Redux/AppCoreReducer.ts";
import { pickResource } from "./pickResource.ts";

export function useResource<T>(resources: Record<LanguageEnum, T>): T {
  const language = useSelector((state: { core: AppCoreState }) => state.core.language);
  return pickResource(resources, language);
}
